import React from "react"
import * as Icon from "react-feather"

const horizontalMenuConfig = [
  {
    id: "dashboard",
    title: "Dashboard",
    type: "item",
    icon: <Icon.Home size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/dashboard",
  },
  
  {
    id: "forms",
    title: "Forms",
    type: "item",
    icon: <Icon.File size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/forms",
  },
  {
    id: "drafts",
    title: "Drafts",
    type: "item",
    icon: <Icon.FileMinus size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/drafts",
  },
  {
    id: "submitted",
    title: "Submitted Forms",
    type: "item",
    icon: <Icon.FileText size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/submitted",
  },
  {
    id: "usermanage",
    title: "User Management",
    type: "item",
    icon: <Icon.Users size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/usermanagement",
  },
  {
    id: "settings",
    title: "Settings",
    type: "item",
    icon: <Icon.Settings size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/settings",
  }
];

export default horizontalMenuConfig;
